//import React, { Component } from 'react';
//import { Route, Routes } from 'react-router-dom';
//import AppRoutes from './AppRoutes';
//import ProtectedRoute  from "./components/Auth/ProtectedRoute";
//import { Layout } from './components/Shared/Layout';
//import './custom.css';
//import "./App.css";
////import AxiosInstance from '../Axios/AxiosInstance';
//export default class App extends Component {
//    static displayName = App.name;
//    render() {
//        return (
//            <Layout>
//                {/*<Routes>*/}
//                {/*    {AppRoutes.map((route, index) => {*/}
//                {/*        const { element, ...rest } = route;*/}
//                {/*        return <Route key={index} {...rest}*/}
//                {/*            element={*/}
//                {/*                <ProtectedRoute>*/}
//                {/*                    element*/}
//                {/*                </ProtectedRoute>*/}
//                {/*             }*/}
//                {/*        />;*/}
//                {/*    })}*/}
//                {/*</Routes>*/}

//                <Routes>
//                    {AppRoutes.map((route, index) => {
//                        // Destructure route properties.
//                        // "element" = component to render
//                        // "isPrivate" = whether route requires authentication
//                        const { element, isPrivate, ...rest } = route;

//                        return (
//                            <Route
//                                key={index}
//                                {...rest}
//                                element={
//                                    // If route is private ? wrap inside ProtectedRoute
//                                    isPrivate ? (
//                                        <ProtectedRoute>
//                                            {/** Authenticated content */}
//                                            {element}
//                                        </ProtectedRoute>
//                                    ) : (
//                                        // Public route ? render component directly
//                                        element
//                                    )
//                                }
//                            />
//                        );
//                    })}
//                </Routes>

//            </Layout>
//        );
//    }
//}

import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";

import AppRoutes from "./AppRoutes";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import { Layout } from "./components/Shared/Layout";

import "./custom.css";
import "./App.css";

// Root application component
// - Defines global layout
// - Registers application routes
export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                {/* 
          Route configuration:
          We loop through AppRoutes (path + component metadata).
          If "isPrivate" is true ? wrap the route with <ProtectedRoute />
          which validates authentication before rendering the page.
        */}
                <Routes>
                    {AppRoutes.map((route, index) => {
                        // element = React component to render
                        // isPrivate = route requires authentication
                        const { element, isPrivate, ...rest } = route;

                        return (
                            <Route
                                key={index}
                                {...rest}
                                element={
                                    isPrivate ? (
                                        // Private route ? require valid token
                                        <ProtectedRoute>
                                            {element}
                                        </ProtectedRoute>
                                    ) : (
                                        // Public route ? render directly
                                        element
                                    )
                                }
                            />
                        );
                    })}
                </Routes>
            </Layout>
        );
    }
}
